let _navigator = null;

function setTopLevelNavigator(navigatorRef) {
  _navigator = navigatorRef;
}

function navigate(routeName, params = null) {
  if (_navigator) {
    if (params) {
      _navigator(routeName, { state: params });
    } else {
      _navigator(routeName);
    }
  } else {
    console.log('Navigator is not set. Cannot navigate.');
    // Fallback to window.location for critical navigation
    if (routeName === '/login') {
      window.location.href = routeName;
    }
  }
}

function reset(routeName, params = null) {
  if (_navigator) {
    if (params) {
      _navigator(routeName, { replace: true, state: params });
    } else {
      _navigator(routeName, { replace: true });
    }
  } else {
    console.log('Navigator is not set. Cannot reset.');
    // Fallback to window.location for critical navigation
    if (routeName === '/login') {
      window.location.href = routeName;
    }
  }
}

function back() {
  if (_navigator) {
    _navigator(-1);
  } else {
    console.log('Navigator is not set. Cannot go back.');
    // Fallback to browser back
    window.history.back();
  }
}

function backMultiple(times = 1) {
  if (_navigator) {
    for (let i = 0; i < times; i++) {
      _navigator(-1);
    }
  } else {
    console.log('Navigator is not set. Cannot go back.');
    // Fallback to browser back
    for (let i = 0; i < times; i++) {
      window.history.back();
    }
  }
}

function backTwice() {
  backMultiple(2);
}

function resetToLogin() {
  if (_navigator) {
    _navigator('/login', { replace: true });
  } else {
    console.log('Navigator is not set. Cannot reset to Login.');
    // Fallback to window.location for critical navigation
    window.location.href = '/login';
  }
}

// Get the current route object safely
function getCurrentRoute() {
  try {
    if (typeof window !== 'undefined') {
      return window.location.pathname;
    }
  } catch (error) {
    // noop
  }
  return null;
}

// Get only the current route name
function getCurrentRouteName() {
  const route = getCurrentRoute();
  return route;
}

export default {
  navigate,
  setTopLevelNavigator,
  reset,
  back,
  backMultiple,
  backTwice,
  resetToLogin,
  getCurrentRoute,
  getCurrentRouteName,
}; 